
import { DocumentFormContainer } from "./DocumentFormContainer"

interface DocumentFormProps {
  type: "oficio" | "requerimento" | "discurso" | "memorando"
  onDocumentGenerated?: (text: string) => void
}

export function DocumentForm(props: DocumentFormProps) {
  return <DocumentFormContainer {...props} />
}
